import type { GetPacksParams } from '../types';

export const packKeys = {
  all: ['packs'] as const,
  lists: () => [...packKeys.all, 'list'] as const,
  list: (filters?: GetPacksParams) => [...packKeys.lists(), filters] as const,
  details: () => [...packKeys.all, 'detail'] as const,
  detail: (id: string) => [...packKeys.details(), id] as const,
  presets: (packId: string) => [...packKeys.detail(packId), 'presets'] as const,
};
